<div class="modal-content main-div">
  <div class="modal-header ">
    <h4 class="modal-title" id="modal-basic-title">
      Select Esign Position
    </h4>
    <div class="d-flex justify-content-start gap-2">
      <div (click)="handleClose()" class="close">
        <img src="../../../../assets/Images/organisation-structure/Cross.svg" alt="cross icon">
      </div>
    </div>
  </div>
  <div class="modal-body body-div">
    <div>
      @if (isPdfLoading) {
        <div>
          <div class="custom-col-width-100 text-danger d-flex justify-content-center">
            <app-common-icon [loadingIcon]="isPdfLoading"></app-common-icon>
          </div>
        </div>
      }
      <div class="container-div">
        <div>
          @if (isShowUsers) {
            <div class="user-section card">
              <div class="card-header">
                @if (isShowUsers) {
                  <span>Select User</span>
                }
              </div>
              <div class="card-body">
                @if (isShowUsers) {
                  <div class=" userDropdown select__dropdown">
                    <div class="select__dropdownLabel">
                      Users
                    </div>
                    <select class="select__dropdownOptions" [(ngModel)]="selectedUser"
                      (change)="handleSelectUser($event)">
                      @for (user of usersList; track user; let index = $index) {
                        <option
                          [ngValue]="user?.emailAddress">
                          {{ user?.name }}
                        </option>
                      }
                    </select>
                  </div>
                }
              </div>
            </div>
          }

          @if (usersList?.length > 0) {
            <div class="user-section card">
              <div class="card-header">
                <div class="user_position_heading">
                  <p>Sign Positions</p>
                  <fa-icon (click)="addNewSignPosition()" [icon]="faPlusCircle"
                  class="custom_edit_faicon"></fa-icon>
                </div>
              </div>
              <div class="card-body">
                <div>
                  @for (sign of usersList[selectedUserIndex]?.signPositions; track sign; let index = $index) {
                    <div class="position_div"
                      [class.activePosition]="selectedSignPositionIndex === index"
                      (click)="handlePositionSelection(index)">
                      <div class="position_heading">
                        <p>Configure Position - {{index + 1}}</p>
                        @if (usersList[selectedUserIndex]?.signPositions?.length > 1) {
                          <fa-icon
                            (click)="removeSignPosition(index)" [icon]="faTrash"
                          class="custom_edit_faicon"></fa-icon>
                        }
                      </div>
                      <div class="position_body"  (click)="handlePositionSelection(index)">
                        <div>
                          <app-checkbox checkboxStatus="{{sign.isCustomPosition}}"
                            checkBoxName="Custom position"
                          (checked)="handleCustomPostion($event, sign)"></app-checkbox>
                        </div>
                        @if (!sign.isCustomPosition) {
                          <div class="select__dropdown">
                            <div class="select__dropdownLabel">
                              Page Type
                            </div>
                            <select class="select__dropdownOptions" [(ngModel)]="sign.pageType"
                              >
                              @for (item of pageTypes; track item) {
                                <option [ngValue]="item?.value">
                                  {{ item?.label }}
                                </option>
                              }
                            </select>
                          </div>
                        }
                        @if (!sign.isCustomPosition) {
                          <div class="select__dropdown">
                            <div class="select__dropdownLabel">
                              Signature Position
                            </div>
                            <select class="select__dropdownOptions"
                              [(ngModel)]="sign.signaturePosition"
                              >
                              @for (item of signaturePositionTypes; track item) {
                                <option
                                  [ngValue]="item?.value">
                                  {{ item?.label }}
                                </option>
                              }
                            </select>
                          </div>
                        }
                        @if (!sign?.pageNumber && !sign?.left && !sign?.top && sign.isCustomPosition) {
                          <p
                            >
                            Drag signature box to set sign position
                          </p>
                        }
                        @if (sign.isCustomPosition) {
                          <div>
                            @if (sign?.pageNumber) {
                              <div class="position_title">Page Number</div>
                            }
                            @if (sign?.pageNumber) {
                              <div class="position_value">{{sign?.pageNumber}}
                              </div>
                            }
                            <div class="d-flex justify-content-start gap-2">
                              <div>
                                @if (sign?.left) {
                                  <div class="position_title">Left</div>
                                }
                                @if (sign?.left) {
                                  <div class="position_value">{{sign?.left}}</div>
                                }
                              </div>
                              <div>
                                @if (sign?.top) {
                                  <div class="position_title">Top</div>
                                }
                                @if (sign?.top) {
                                  <div class="position_value">{{sign?.top}}</div>
                                }
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>

        <div class="signBoxDiv">
          <div class="d-flex justify-content-end mb-2" [ngClass]="handleEsignStyleClass() ? 'display-block' : 'display-none'">
            <div class="esign-box" #esignBoxElement>
              Signature
            </div>
          </div>


          <div class="thumbnaildiv" [class.thumbnail-position]="handleEsignStyleClass()">
            @for (item of thumbnail; track item) {
              <div id="page{{item.page}}"
                (click)="handleThumbnailClick(item.page)">
                <div class="thumbnail">
                  <img [class.selected]="page.value === item.page" alt="thumbnail esign-Position" class="thumbnailImage"
                    src="{{item.url}}">
                  </div>
                  <div class="pagenumberDiv">
                    <p class="pagenumber">{{item.page}}</p>
                  </div>
                </div>
              }
            </div>
          </div>
          <div>
            @if (pdfSrc) {
              <div class="pdf-container">
                <pdf-viewer [src]="pdfSrc" [zoom]="0.75" [page]="page.value" [show-all]="false"
                  [render-text]="true" style="display: block;"
                (after-load-complete)="callBackFn($event)"></pdf-viewer>
                @if (thumbnailPdfview) {
                  <div style="visibility: hidden;">
                    <pdf-viewer [src]="pdfSrc" [render-text]="true" [original-size]="false"
                    (page-rendered)="pageRendered($event)" style="width: 100px; height: 100px"></pdf-viewer>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer row">
      <div class="footer-actions col-md-6">
        <div class="page-actions">
          <div class="page-icon">
            <span data-bs-toggle="tooltip" ngbTooltip="Previous Page" [placement]="'left'">
              <div (click)="decreasePageNumber()" tooltipClass="custom-tooltip"
                class="btn btn-primary btn-sm b-btn">
                <app-common-icon [faIcon]="faCaretLeft"></app-common-icon>
              </div>
            </span>
          </div>
          <div>
            <app-input-filed placeholder="Enter Page Number" [type]="'number'" [value]="page.value"
            [control]="page" allowedType="number" [min]="1" [max]="totalPages"></app-input-filed>
          </div>
          <div class="page-icon">
            <span data-bs-toggle="tooltip" ngbTooltip="Next Page" [placement]="'right'">
              <div (click)="increasePageNumber()" tooltipClass="custom-tooltip"
                class="btn btn-primary btn-sm me-2 b-btn">
                <app-common-icon [faIcon]="faCaretRight"></app-common-icon>
              </div>
            </span>
          </div>
        </div>
        <div class="d-flex">
          <app-common-button class="m-1" buttonClass="smallbutton" [buttonLabel]="'Cancel'"
            (click)="handleClose()">
          </app-common-button>
          <app-common-button class="m-1" buttonClass="smallFilledButton" [buttonLabel]="'Submit'"
            (click)="successClose()">
          </app-common-button>
        </div>
      </div>
    </div>
  </div>
